import picomatch from "picomatch";

import type { TraceElement } from "./types.js";

export interface ExtractTraceElementsOptions {
  artifactId: string;
  pathPatterns: string[];
  excludePatterns?: string[];
  /** Known file paths to match against (project-relative). */
  files: string[];
}

/**
 * Return file-level trace elements for an artifact by matching known project
 * files against `path_patterns` and filtering `exclude_patterns`.
 */
export function extractTraceElements(
  options: ExtractTraceElementsOptions,
): TraceElement[] {
  const {
    artifactId,
    pathPatterns,
    excludePatterns = [],
    files,
  } = options;

  if (pathPatterns.length === 0 || files.length === 0) {
    return [];
  }

  const elements: TraceElement[] = [];

  for (const filePath of files) {
    if (!picomatch.isMatch(filePath, pathPatterns)) continue;
    if (
      excludePatterns.length > 0 &&
      picomatch.isMatch(filePath, excludePatterns)
    ) {
      continue;
    }
    elements.push({ artifactId, path: filePath, kind: "file" });
  }

  elements.sort((a, b) => a.path.localeCompare(b.path));
  return elements;
}
